<template>
    <v-form v-model="valid">
        <v-row>
            <v-col>
                <v-text-field
                    v-model="title"
                    autofocus
                    label="Judul tryout"
                    prepend-icon="mdi-format-text"
                    :rules="rules.title"
                ></v-text-field>
            </v-col>

            <v-col>
                <v-text-field
                    v-model="minute_limit"
                    type="number"
                    label="Waktu pengerjaan (menit)"
                    prepend-icon="mdi-timer"
                    :rules="rules.minute_limit"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-menu
                    v-model="dateDialog"
                    offset-y
                    max-width="300"
                >
                    <template #activator="{ on }">
                        <v-text-field
                            v-on="on"
                            @keyup.enter="dateDialog = true"
                            :value="released_date"
                            readonly
                            label="Tanggal rilis tryout"
                            prepend-icon="mdi-calendar"
                            :rules="rules.released_date"
                        ></v-text-field>
                    </template>

                    <v-date-picker
                        v-model="released_date"
                        locale="id-ID"
                        no-title
                        full-width
                        color="primary"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col>
                <v-menu
                    v-model="timeDialog"
                    ref="timeMenu"
                    :close-on-content-click="false"
                    offset-y
                    max-width="300"
                >
                    <template #activator="{ on }">
                        <v-text-field
                            v-on="on"
                            @keyup.enter="timeDialog = true"
                            :value="released_time"
                            readonly
                            label="Waktu rilis tryout"
                            prepend-icon="mdi-clock-outline"
                            :rules="rules.released_time"
                        ></v-text-field>
                    </template>

                    <v-time-picker
                        v-model="released_time"
                        format="24hr"
                        full-width
                        header-color="primary"
                        @click:minute="$refs.timeMenu.save()"
                    ></v-time-picker>
                </v-menu>
            </v-col>
        </v-row>

        <v-checkbox
            v-model="questionRandomized"
            label="Acak Soal"
        >
        </v-checkbox>

        <v-row justify="center">
            <v-col cols="4">
            </v-col>
            <v-col cols="4">
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { sync } from 'vuex-pathify'
import rules from '@/validations/TryoutData'

export default {
    data() {
        return {
            valid: null,
            rules,
            dateDialog: false,
            timeDialog: false,
        }
    },

    computed: sync('createtryout/input@*'),

    watch: {
        valid(to) {
            this.$emit('input', to)
        }
    }
}
</script>
